var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{class:_vm.classes,attrs:{"to":{ name: 'asset', params: { symbol: _vm.asset.symbol, assetContext: _vm.asset }}}},[_vm._v(_vm._s(_vm.asset.symbol)),(_vm.offsetSymbol)?_c('span',{class:_vm.offsetClass},[_vm._v(_vm._s(_vm.offsetSymbol))]):_vm._e(),_vm._v(" "+_vm._s(_vm.emojis))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }